export default __webpack_public_path__ + "static/media/ic_filter.0c3d362a.svg";